import store from './store.dev'

export default store
